import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SettingsBox from '@medflex/components/stories/SettingsBox';
import { Switch } from '@medflex/components/stories/Switch';

import useUserProfile from '../hooks/useUserProfile';

const AppNotificationsSettingsModule = () => {
  const [checked, setChecked] = useState(null);
  const { t } = useTranslation();
  const { userProfile, updatePushSettings } = useUserProfile();

  const onChange = value => {
    updatePushSettings(value);
  };

  useEffect(() => {
    if (!userProfile || !userProfile.attributes || !userProfile.attributes.notificationSettings)
      return;
    const newValue = userProfile.attributes.notificationSettings.push;
    setChecked(newValue);
  }, [userProfile]);

  if (checked === null) {
    return null;
  }

  return (
    <div data-component="AppNotificationsSettingsModule">
      <header className="mb-6 flex items-center">
        <h2 className="text-2xl font-semibold">
          {t('global:AppNotificationsSettingsModule.title')}
        </h2>
      </header>
      <p className="mb-6">{t('global:AppNotificationsSettingsModule.description')}</p>
      <div className="mb-6">
        {t('global:AppNotificationsSettingsModule.help_advice')}
        <div>
          <a
            className="text-blue-500"
            href="https://medflex.de/hilfe/behandler-apps/benachrichtigungen"
            target="_blank"
            rel="noreferrer"
          >
            {t('global:AppNotificationsSettingsModule.help_link_text')}
          </a>
        </div>
      </div>
      <SettingsBox>
        <div className="flex justify-between items-center">
          <p className="text-slate-900 text-base font-semibold leading-6">
            {t('global:AppNotificationsSettingsModule.switch_label')}
          </p>
          <Switch className="h-4 w-4 cursor-pointer" checked={checked} onChange={onChange} />
        </div>
      </SettingsBox>
    </div>
  );
};

export default AppNotificationsSettingsModule;
